export default __webpack_public_path__ + "static/media/screen_chat_gpt_4.76e9fc23.png";